import { HttpRequest } from "../utils"

const httpRequest = new HttpRequest()

export interface IClassificationRule {
  id: string
  businessId: string
  sizeScaleId: string
  name: string
  smallThreshold: string
  largeThreshold: string
  weightThreshold: string | null
  smallChannel: string | null
  largeChannel: string | null
  mediumChannel: string | null
  sizeAggregation: string
  packingEfficiency: string
  isActive: boolean
  priority: number
  createdByUserId: string
  createdAt?: string
  updatedAt?: string
}

export interface IClassificationRulesResponse {
  rows: IClassificationRule[]
  count: number
}

export interface ICreateClassificationRuleInput {
  sizeScaleId: string
  name: string
  smallThreshold: number
  largeThreshold: number
  weightThreshold?: number | null
  smallChannel?: string | null
  largeChannel?: string | null
  mediumChannel?: string | null
  sizeAggregation?: "SUM" | "MAX" | "WEIGHTED"
  packingEfficiency?: number
  isActive?: boolean
  priority?: number
}

export const create = async (data: ICreateClassificationRuleInput): Promise<IClassificationRule> =>
  httpRequest.post("/ord/size-classification-rule", data as any)

export const list = async (data: {
  filter?: { search?: string; isActive?: boolean; sizeScaleId?: string }
  offset?: { limit: number; skip: number }
  order?: Array<[string, string]>
}): Promise<IClassificationRulesResponse> =>
  httpRequest.post("/ord/size-classification-rule/list", data as any)

export const get = async (id: string): Promise<IClassificationRule> =>
  httpRequest.get(`/ord/size-classification-rule/${id}`)

export const update = async (
  id: string,
  patch: Partial<ICreateClassificationRuleInput>,
): Promise<IClassificationRule> =>
  httpRequest.put(`/ord/size-classification-rule/${id}`, patch as any)

export const remove = async (id: string): Promise<{ removed: boolean; reason?: string }> =>
  httpRequest.del(`/ord/size-classification-rule/${id}`)
